import config from 'config'
import { getJsonHeaders } from './helpers'

export async function list(limit = 15, page = 1) {
  try {
    const result = await fetch(
      config.API_URL + `/api/discount-codes?per_page=${limit}&page=${page}`
    )
    return await result.json()
  } catch (e) {
    return false
  }
}

export async function get(id) {
  try {
    const result = await fetch(config.API_URL + `/api/discount-codes/${id}`)
    return await result.json()
  } catch (e) {
    return false
  }
}

export async function validate(code) {
  try {
    const result = await fetch(config.API_URL + `/api/discount-codes/validate/${code}`)
    if (result.status === 200) {
      return await result.json()
    }
    return false
  } catch (e) {
    return false
  }
}

export async function create(body) {
  try {
    const res = await fetch(config.API_URL + `/api/discount-codes`, {
      method: 'POST',
      headers: await getJsonHeaders(),
      body: JSON.stringify(body),
    })

    if (res.status === 201) {
      return {
        success: true,
        message: 'Successfully created discount code',
      }
    }

    const decoded = await res.json()
    return {
      success: false,
      message: decoded.message,
      errors: Object.entries(decoded.errors).map(error => {
        return error
      }),
    }
  } catch (e) {
    return {
      success: false,
      message: 'Failed to create discount code',
    }
  }
}

export async function update(id, body) {
  try {
    const res = await fetch(config.API_URL + `/api/discount-codes/${id}`, {
      method: 'PUT',
      headers: await getJsonHeaders(),
      body: JSON.stringify(body),
    })

    if (res.status === 200) {
      return {
        success: true,
        message: 'Successfully updated discount code',
      }
    }

    const decoded = await res.json()
    return {
      success: false,
      message: decoded.message,
      errors: Object.entries(decoded.errors).map(error => {
        return error
      }),
    }
  } catch (e) {
    return {
      success: false,
      message: 'Failed to update discount code',
      errors: [['', 'Failed to update discount code']],
    }
  }
}

export async function deleteDiscountCode(id) {
  try {
    const res = await fetch(config.API_URL + `/api/discount-codes/${id}`, {
      method: 'DELETE',
      headers: await getJsonHeaders(),
      body: JSON.stringify({}),
    })

    if (res.status === 204) {
      return true
    }

    return false
  } catch (e) {
    return false
  }
}

export async function enableToggle(enabled) {
  try {
    const body = {
      enabled: enabled ? 1 : 0,
    }

    const res = await fetch(config.API_URL + `/api/discount-codes/enable-toggle`, {
      method: 'POST',
      headers: await getJsonHeaders(),
      body: JSON.stringify(body),
    })

    if (res.status === 200) {
      return {
        success: true,
        message: 'Successfully toggled enabled status',
      }
    }

    return {
      success: false,
      message: 'Failed to toggle enabled status',
    }
  } catch (e) {
    return {
      success: false,
      message: 'Failed to toggle enabled status',
    }
  }
}
